module.exports = __webpack_public_path__ + "media/images/ceremony/top/reason3-35deb62beaf7cf03f14d4c51c7c836f8.jpg";